import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

import { mockData } from "./mockData";

export const getCTAs = async ({ fundID }) => {
  const endpoint = `/give/callToActions/${fundID}`;

  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.getCTAs)
    : new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};
